import consoleLogger from '../../logger/consoleLogger';
import { ClientToJsInterface } from '../clientToJsInterface';
import { getCommandHandler } from '../../webApp/getCommandHandler';
import { WebCommands } from '../../webApp/webCommands';

const logger = consoleLogger.getPrefixedCopy('WEBGL_TO_JS');

type JsFromClientCommand = {
    method: WebCommands,
    params: string
};

export class WebglJsInterface implements ClientToJsInterface {
    public expose() {
        logger.info('Exposing interface');
        window.app.webglInterface = function sendCommandToWebApp(rawCommand: string) {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            let handler: any;
            let command: JsFromClientCommand;
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            let params: { [key: string]: any };

            logger.info('ACCEPTED COMMAND RAW', rawCommand);

            try {
                command = JSON.parse(rawCommand);
                logger.info('PARSED COMMAND', command);
                if (command.params) {
                    params = JSON.parse(command.params);
                } else {
                    params = {};
                }
                handler = getCommandHandler(command.method);
                logger.info('handler found', command);
                handler.handle(params);
            } catch (error) {
                const methodName = command && command.method ? command.method : 'N/A';
                logger.error(`WebGlJsInterface error (${methodName})`, error);
                window.Sentry.captureException(error);
            }
        };
    }
}
